import Vue from "vue";

export default Vue.component("guarantee-notice", {

    props:
        {
            template:
                {
                    type: String,
                    default: "#vue-guarantee-notice"
                }
        }
});
